/**
 * SearchQueries component.
 */
import ArrowContainer from '@components/atoms/container/searchQueryArrowContainer';
import ArrowUpIcon from '@components/atoms/icons/arrowUp';
import Direction from '@shared/types/enums/direction';
import Focus from '@shared/types/enums/focus';
import List from '@components/sections/list/list';
import Query from '@components/elements/search/query';
import QueriesContainer from '@components/atoms/container/searchQueryContainer';
import useTransform from '@shared/components/utils/hooks/useTransform';
import { AutoComplete } from '@shared/types/interfaces/search';
import { useState } from 'react';

/**
 * Constants
 */
const ITEM_OFFSET = 46;

/**
 * Props for the SearchQueries component.
 */
interface Props {
  queries: AutoComplete[];
  action: (query: AutoComplete) => void;
  outOfBounds: (focus: string | number, exit?: string | undefined) => void;
}

/**
 * Renders the search queries list.
 */
export default function SearchQueries({ queries, action, outOfBounds }: Props) {
  const [index, setIndex] = useState(0);
  const [style, setStyle] = useTransform(0, ITEM_OFFSET, Direction.VERTICAL);

  const onChange = (index: number, increment = 1) => {
    setIndex(index);
    setStyle(increment);
  };

  return (
    <>
      <ArrowContainer opacity={index > 0 ? 1 : 0}>
        <ArrowUpIcon />
      </ArrowContainer>
      <QueriesContainer>
        <div style={style}>
          <List
            direction={Direction.VERTICAL}
            focus={Focus.QUERY_LIST}
            initialIndex={0}
            onChange={onChange}
            outOfBounds={outOfBounds}
          >
            {queries.map((query, index) => {
              return (
                <Query
                  action={() => action(query)}
                  index={index}
                  key={index}
                  query={query}
                />
              );
            })}
          </List>
        </div>
      </QueriesContainer>
    </>
  );
}
